import Budget from "models/Budget";
import { GenericService, Service } from "./genericService";
import axios from "axios";
import HasProUser from "models/ProUser";

class ProUserService extends GenericService<Budget> implements Service<Budget> {
  constructor() {
    super("api/proUser");
  }

  hasPro = async (destinationId: number): Promise<HasProUser> => {
    const result = await axios.get(`${this.baseUrl}/${destinationId}/hasPro`);
    return result.data;
  };

  chat = async (proId: string): Promise<void> => {
    await axios.post(`${this.baseUrl}/${proId}/chat`);
  };
}

export default new ProUserService();
